"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEEddystone = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const MACAddress_1 = require("./MACAddress");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BLEUUID_1 = require("./BLEUUID");
const BufferUtils_1 = require("../utils/BufferUtils");
let BLEEddystone = class BLEEddystone extends BLEBeaconObject_1.BLEBeaconObject {
    constructor(address, scanData) {
        super(address);
        if (scanData) {
            this.parseAdvertisement(scanData);
        }
    }
    isValid() {
        return this.service !== undefined;
    }
    parseAdvertisement(payload) {
        super.parseAdvertisement(payload);
        const service = this.service;
        if (service) {
            const view = new DataView(service.data.buffer, 0);
            this.frame = view.getInt8(0);
            this.txPower = view.getInt8(1);
        }
        return this;
    }
    parseServiceData(uuid, serviceData) {
        super.parseServiceData(uuid, serviceData);
        if (!(0, BufferUtils_1.arrayBuffersAreEqual)(uuid.toBuffer().buffer, BLEUUID_1.BLEUUID.fromString('FEAA').toBuffer().buffer)) {
            return this;
        }
        const view = new DataView(serviceData.buffer, 0);
        this.frame = view.getInt8(0);
        if (this.frame !== 0x20) {
            this.setCalibratedRSSI(view.getInt8(1), 0, core_1.LengthUnit.METER);
        }
        return this;
    }
    get service() {
        return this.getServiceByUUID(BLEUUID_1.BLEUUID.fromString('FEAA'));
    }
};
exports.BLEEddystone = BLEEddystone;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEEddystone.prototype, "frame", void 0);
exports.BLEEddystone = BLEEddystone = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [MACAddress_1.MACAddress, Uint8Array])
], BLEEddystone);
//# sourceMappingURL=BLEEddystone.js.map